module.exports = __webpack_public_path__ + "static/media/l_retok.21fb529e.png";